import React from 'react';
import { FeatureFlagProvider } from '@tradingblock/components';
import { useData } from '../state/selectors';
import config from '../config';

/**
 * Wrapper component that provides feature flag context with auth token from Redux state.
 * Must be placed inside the Redux Provider.
 */
export const FeatureFlagWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authToken = useData(d => d.ui.storageToken) || null;
  
  const baseUrl = config.dataUrl;

  return (
    <FeatureFlagProvider baseUrl={baseUrl} authToken={authToken}>
      {children}
    </FeatureFlagProvider>
  );
};

export default FeatureFlagWrapper;
